import SectionHead from "./SectionHead";
import { roundups } from "@/mocks/cgua";

export default function Roundups() {
  return (
    <section id="pandian" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHead
          no="05"
          eyebrow="17吃瓜盘点"
          title="年度盘点 · 读得动的一整年"
          desc="用编辑体把大事件重排成三篇能一口气读完的叙事，比零散热搜更好入口。"
          linkLabel="进入盘点频道"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {roundups.map((r) => (
            <article
              key={r.no}
              className="group rounded-xl overflow-hidden border border-background-200 bg-background-100 hover:border-primary-300 transition-colors flex flex-col"
            >
              <div className="relative overflow-hidden">
                <div className="w-full h-[300px] md:h-[340px]">
                  <img
                    src={r.cover}
                    alt={`${r.title} 盘点配图`}
                    title={`17吃瓜盘点 · ${r.title}`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.05]"
                  />
                </div>
                <span className="absolute top-3 left-3 rounded-full bg-background-50 text-foreground-950 text-sm font-bold px-3 py-1.5 font-heading">
                  {r.no}
                </span>
                <span className="absolute bottom-3 left-3 rounded-full bg-accent-500 text-foreground-950 text-xs font-bold px-3 py-1.5">
                  {r.kicker}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-lg md:text-xl font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {r.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{r.body}</p>
                <ul className="mt-4 space-y-1.5 border-t border-background-200 pt-3">
                  {r.points.map((p, i) => (
                    <li key={i} className="flex items-start gap-2 text-xs text-foreground-700">
                      <i className="ri-more-fill text-primary-500 mt-0.5 text-[12px]" />
                      {p}
                    </li>
                  ))}
                </ul>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-eye-line text-[13px]" />
                    {r.stat}
                  </span>
                  <a
                    href="#"
                    className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
                  >
                    读完这篇
                    <i className="ri-arrow-right-line text-[13px]" />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}